import React from "react";
import { DataNotFound } from "../../../../Components/SharedComponent/ReviewSummarySectionNotFound/DataNotFound";
import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import { toTitleCase } from "../../../../Utils/stringUtls";
import { i2cServerOptionSelect } from "../../ConnectivityAndCommunication/stringUtils";

const ConnectivityAndCommunicationLinkOverview = ({ data }) => {
  if (!data) return <DataNotFound />;

  const vpnData = data["5_0"] || {};
  const serverData = data["5_1"] || {};

  const {
    virtual_private_network_secure_vpn_setup_with_i2c,
    virtual_private_network_secure_communication_and_connectivity_via_secure_vpn = [],
    virtual_private_network_secure_communication_and_connectivity_via_secure_vpn_other,
  } = vpnData;

  const {
    server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like,
    server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like_other,
    server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement,
    server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement_other,
  } = serverData;

  const vpnOptionsValue = [
    ...(virtual_private_network_secure_communication_and_connectivity_via_secure_vpn || [])
      .filter((o) => o?.length && o !== "other")
      .map((o) => o.split("_").map(toTitleCase).join(" ")),
    ...(virtual_private_network_secure_communication_and_connectivity_via_secure_vpn?.includes("other") &&
    virtual_private_network_secure_communication_and_connectivity_via_secure_vpn_other?.length
      ? [`Other (${toTitleCase(virtual_private_network_secure_communication_and_connectivity_via_secure_vpn_other)})`]
      : []),
  ].join(", ");

  return (
    <React.Fragment>
      <div className="forms-instance" style={{ color: "#111" }}>
        <div i2c-grid="grid grid" className="review-summary-gap">
          <div i2c-grid="12@md" className="review-summary-sub-heading">
            <div className="fw-700 font-bold">Virtual Private Network (VPN)</div>
          </div>
          <ReviewAttribute
            label="Secure Virtual Private Network (VPN) Setup with i2c?"
            value={virtual_private_network_secure_vpn_setup_with_i2c?.length ? toTitleCase(virtual_private_network_secure_vpn_setup_with_i2c) : "-"}
          />
          {virtual_private_network_secure_vpn_setup_with_i2c === "yes" && (
            <ReviewAttribute
              label="Communication & Connectivity via Secure VPN"
              value={vpnOptionsValue || "-"}
            />
          )}
        </div>
      <div className="divider-bottom mt-16 mb-16"></div>
      </div>
      <div className="forms-instance" style={{ color: "#111" }}>
        <div i2c-grid="grid grid" className="review-summary-gap">
          <div i2c-grid="12@md" className="review-summary-sub-heading">
            <div className="fw-700 font-bold">Server-to-Server Communication Link for File Exchange</div>
          </div>
          <ReviewAttribute
            label="What type of server-to-server communication would you like to use?"
            value={
              server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like === "other"
                ? server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like_other || "-"
                : server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like?.length
                ? server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like.toUpperCase()
                : "-"
            }
          />
          <ReviewAttribute
            label="Would you like to use i2c server for file placement?"
            value={
              server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement?.length
                ? server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement === "other"
                  ? `Other (${server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement_other || "-"})`
                  : i2cServerOptionSelect.find(
                      (option) =>
                        option.value ===
                        server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement,
                    )?.label || toTitleCase(server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement)
                : "-"
            }
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ConnectivityAndCommunicationLinkOverview;
